/* eslint-disable camelcase */
import 'animate.css';

import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import LogoRoutal from '../../../assets/svg/LogoRoutal';
import NorthStarIcon from '../../../assets/svg/NorthStarIcon';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { OnboardingContent } from '../Onboarding.styled';

interface StartProps {
  onNextStep: () => void;
}

export const Start = ({ onNextStep }: StartProps) => {
  const startOnboarding = () => {
    const element = document.getElementById(`startOnboardingAnimatedContainer`);
    if (element) {
      element.classList.remove(`animate__fadeInUp`);
      element.classList.add(`animate__fadeOutUp`);
      setTimeout(() => {
        onNextStep();
      }, 500);
    } else {
      onNextStep();
    }
  };

  return (
    <OnboardingContent
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      style={{
        width: `100vw`,
        height: `100vh`,
      }}
      className="animate__animated animate__fadeIn"
    >
      <Grid item style={{ position: `absolute`, top: `30px`, left: `30px`, display: `flex` }}>
        <LogoRoutal style={{ color: RoutalPalette.neutral00, height: `22px`, width: `120px` }} />
        <NorthStarIcon width="12px" height="12px" />
      </Grid>

      <Grid
        id="startOnboardingAnimatedContainer"
        item
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="animate__animated animate__fadeInUp"
      >
        <Grid item style={{ maxWidth: `800px` }} display="flex" flexDirection="column">
          <Text
            style={{ textAlign: `center`, color: RoutalPalette.neutral02n }}
            variant="h3"
            intlId="company.onboarding.start.title"
          />
          <VSpacer small />
          <Text
            style={{ textAlign: `center`, color: RoutalPalette.neutral02n }}
            variant="body-large"
            intlId="company.onboarding.start.subtitle"
          />
        </Grid>

        <VSpacer medium />

        <Button
          styleType="primary"
          style={{
            width: `250px`,
            height: `35px`,
            padding: 0,
            margin: 0,
          }}
          onClick={() => {
            startOnboarding();
          }}
        >
          <Grid display="flex" flexDirection="row" alignItems="center">
            <Text
              variant="body"
              intlId="company.onboarding.start.button"
              style={{ marginRight: `4px`, color: RoutalPalette.neutral02n, cursor: `pointer` }}
            />
            <NorthStarIcon width="11px" height="11px" style={{ cursor: `pointer` }} />
          </Grid>
        </Button>
      </Grid>
    </OnboardingContent>
  );
};
